import React, { useState } from "react";
import { FaRegEyeSlash } from "react-icons/fa6";
import { FaRegEye } from "react-icons/fa6";
import { publicRequest } from "../request";
import { setUser } from "../redux/userSlice";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

const SignIn = () => {
    const navigate = useNavigate();
  const [showPass, setShowPass] = useState(false);
  const togglePass = () => {
    setShowPass(!showPass);
  };
  const [emailError,setEmailError] = useState(false);
  const [passwordError,setPasswordError] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(false);
  const dispatch = useDispatch();

  const validate = ()=>{
    if(email === ""){
        setEmailError(true);
    }
    if(password === ""){
        setPasswordError(true);
    }
    else{
        setEmailError(false);
        setPasswordError(false);
        return true;
    }
    return false;
  }
  const handleSubmit = async (e) => {
   if(validate()){
    try {
        e.preventDefault();
        const response = await publicRequest.post("/auth/login", {
          email,
          password,
        });
        console.log(response);
  
        if (response.status === 200) {
          dispatch(setUser(response.data.userResponse));
          toast.success("Login successful!");
          navigate("/admin");
          setError(false);
        } else {
          setError(true);
        }
      } catch (err) {
        setError(true);
        console.log(err);
      }
   }
    
  };
  return (
    <div className="signin relative flex lg:justify-center items-center lg:w-min w-full p-4">
      <div className=" lg:border lg:shadow-xl flex flex-col gap-6 rounded-md lg:p-10 lg:bg-white w-full pt-10">
        <h1 className="text-xl lg:text-center">
          Login to get started
        </h1>
        <div className="email flex flex-col">
        <label htmlFor="email" className={` ${emailError?"text-red-500":"text-gray-500"} `}>
            Email
          </label>
          <input
            type="text"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className={`p-2 rounded-lg border-2 ${emailError?"border-red-500":""} w-full md:w-[20vw]`}
            placeholder="xyz@gmail.com"
          />
          {
            emailError && (
              <p className=" text-red-500">
                Email is required!
              </p>
            )
          }
        </div>
        <div className="password flex flex-col">
          <label htmlFor="password" className={` ${passwordError?"text-red-500":"text-gray-500"} `}>
            Password
          </label>
          <div className={`p-2 rounded-lg  border-2  ${passwordError? "border-red-500":""} w-full md:w-[20vw] flex justify-between`}>
            <input
              type={showPass ? "text" : "password"}
              className="outline-none"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter the password"
            />
            <button>
              {showPass ? (
                <FaRegEyeSlash onClick={togglePass} />
              ) : (
                <FaRegEye onClick={togglePass} />
              )}
            </button>
          </div>
          {
            passwordError && (
              <p className=" text-red-500">
                Password is required!
              </p>
            )
          }
        </div>
        <div className="flex justify-end">
          <p className=" text-primary">Forgot password?</p>
        </div>

        {error && (
          <div className=" lg:hidden flex justify-start">
            <p className=" text-red-500 text-center">invalid username!</p>
          </div>
        )}
        <div className=" flex justify-center items-center">
          <button
            className="bg-primary text-white p-2 rounded-full w-full"
            onClick={handleSubmit}
          >
            Login
          </button>
        </div>
        
      </div>
      {error && (
        <div className=" hidden lg:block absolute -bottom-10">
          <p className=" text-red-500 text-center">invalid credentials!</p>
        </div>
      )}
    </div>
  );
};

export default SignIn;
